/**
 * @author [leiling.cp]
 */

module.exports = require("./src/alipush-client.js");